module.exports = __webpack_public_path__ + "resources/img/logo_footer_nhn_jp.f9c441236cded114cd94b9da6d828ba1.png";